// extracted by mini-css-extract-plugin
export default {"table":"AVh0x","header":"VA3oQ","parameters":"ibpfW","cell":"q8CUw","parameterName":"Qfaj6","row":"VnzNA"};